import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Box, Divider, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Template } from "../../../DesignEditor/models/template";
import { IMenuItem } from "../../../DesignEditor/views/DesignEditor/components/Panels/panelItems/Templates/Templates";
import { EditIcon } from "../../../assets/images/icons/EditIcon";
import useHoverOverlay from "../../../hooks/useHoverOverlay";
import { useAppStore } from "../../../hooks/useStores";
import CopyToClipboardButton from "../CopyToClipboardButton/CopyToClipboardButton";
import styles from "./TemplateImageOverlay.module.scss";
export type EditorImageOverlayProps = {
	menuItems: IMenuItem[];
	template: Template;
	isPopupView: boolean;
};

const TemplateImageOverlay = ({ menuItems, template, isPopupView }: EditorImageOverlayProps) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const [hoverRef, isHovered, setIsHovered] = useHoverOverlay();
	const { campaignStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "editor.tabs.templates" });
	const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};
	const handleMenuClose = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(null);
		event.stopPropagation();
	};
	return (
		<Box ref={hoverRef}>
			<Box className={styles.overlayContent}>
				<Box
					style={{ visibility: isHovered || Boolean(anchorEl) ? "visible" : "hidden" }}
					className={styles.lableContainer}
				>
					<Typography className={styles.nameLabel}>{template?.name}</Typography>
					<Typography className={styles.numberOfAdslabel}>
						{t("view")} {template?.ads_json?.scenes?.length} {t("ads")}
					</Typography>
				</Box>
				{!isPopupView && (
					<IconButton
						className={styles.iconButton}
						onClick={handleMenuOpen}
						style={{ visibility: isHovered || Boolean(anchorEl) ? "visible" : "hidden" }}
					>
						<MoreHorizIcon className={styles.MoreHorizIcon} />
					</IconButton>
				)}
				<Menu
					onClick={(e) => {
						e.stopPropagation();
					}}
					classes={{ paper: styles.paper }}
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={handleMenuClose}
					MenuListProps={{
						onMouseEnter: () => setIsHovered(true),
						onMouseLeave: () => !anchorEl && setIsHovered(false),
					}}
				>
					<Box className={styles.templateNameWrapper}>
						<Typography className={styles.templateNameLabel}>{template.name}</Typography>
						<EditIcon
							onClick={(e) => {
								campaignStore.templateToUpdateInfo = template;
								campaignStore.templateNameToUpdateInfo = template.name;
								campaignStore.openUpdateTemplatePopup = true;
								e.stopPropagation();
							}}
							className={styles.editIcon}
						/>
					</Box>

					<Box className={styles.copyId}>
						<Typography className={styles.templateNameId}>{t("id")}</Typography>
						<Typography className={styles.templateNameId}>{template.id}</Typography>
						<CopyToClipboardButton className={styles.copyIcon} textToCopy={template.id?.toString()} />
					</Box>
					<Divider />
					<Box>
						{menuItems.map((item: IMenuItem, index: number) => (
							<MenuItem
								key={index}
								onClick={(e: any) => {
									e.stopPropagation();
									item.onClick(template);
									handleMenuClose(e);
								}}
								classes={{
									root: styles.menuItemRoot,
								}}
							>
								<Box className={styles.menuIconWrapper}>
									<img src={item.icon} />
									<Typography className={styles.menuLabel}>{item.label}</Typography>
								</Box>
							</MenuItem>
						))}
					</Box>
				</Menu>
			</Box>
		</Box>
	);
};

export default TemplateImageOverlay;
